import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import HeroSection from './components/HeroSection';
import TrustLogoStrip from './components/TrustLogoStrip';
import ServicesSection from './components/ServicesSection';
import StatsSection from './components/StatsSection';
import ProcessSection from './components/ProcessSection';
import SuccessStoriesSection from './components/SuccessStoriesSection';
import JobMarketplaceCTA from './components/JobMarketplaceCTA';
import CTASection from './components/CTASection';
import { useLanguage } from '../../contexts/LanguageContext';

const Homepage = () => {
  const { t, language } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet htmlAttributes={{ lang: language === 'zh' ? 'zh-CN' : 'en' }}>
        <title>{t('home.seo.title')}</title>
        <meta name="description" content={t('home.seo.description')} />
        <meta name="keywords" content={t('home.seo.keywords')} />
      </Helmet>

      <div className="min-h-screen flex flex-col bg-background overflow-x-hidden">
        <Header />

        <main className="flex-1 pt-16">
          {/* Section 1: Hero */}
          <HeroSection />

          {/* Section 2: Trust / Logo Strip */}
          <TrustLogoStrip />

          {/* Section 3: Services / Capabilities Overview */}
          <ServicesSection />

          {/* Section 4: Stats / Impact Band with Count-Up Animations */}
          <StatsSection />

          {/* Section 5: How It Works / Engagement Process */}
          <ProcessSection />

          {/* Section 6: Success Stories & Client Testimonials */}
          <SuccessStoriesSection />

          {/* Section 7: Job Marketplace / Career CTA Band */}
          <JobMarketplaceCTA />

          {/* Section 8: Final Enterprise CTA Band */}
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Homepage;
